module.exports = __webpack_public_path__ + "static/sg-449a87355f748dfea24dd6127bc4d931.jpg";